export default __webpack_public_path__ + "static/media/a-a-a-de-winter-de-isch-da.d6fd72b5.pdf";